//
// Module for the Account Transaction adjustment's page.
//
rs.module("content/participant/member/disabilityapplication/earningssafeguardedit",

    [/* Dependencies */],

    function () {

        function initialize(jsSelectors, backendUrls, disabilityKey) {
            var earningsSafeguardForm = $.js(jsSelectors.earningsSafeguardForm);
            var calculateButton = earningsSafeguardForm.js(jsSelectors.calculateButton);
            var earningsSafeguardAmount = earningsSafeguardForm.js(jsSelectors.earningsSafeguardAmount);
            var retirementAllowanceAmount = earningsSafeguardForm.js(jsSelectors.retirementAllowanceAmount);
            var excessEarningsAmount = earningsSafeguardForm.js(jsSelectors.excessEarningsAmount);
            var beginDate = earningsSafeguardForm.js(jsSelectors.beginDate, { required: false});
            var endDate = earningsSafeguardForm.js(jsSelectors.endDate, { required: false });
            var bargainingUnit = earningsSafeguardForm.js(jsSelectors.bargainingUnit, { required: false });
            var outsideEarningsAmount = earningsSafeguardForm.js(jsSelectors.outsideEarningsAmount, { required: false });
            var governmentReportedEarningAmount = earningsSafeguardForm.js(jsSelectors.governmentReportedEarningAmount, { required: false });



            // Handle the calculate by calling a BAP
            calculateButton.click(function () {
                // make the call to load repayment detail

                $.get(
                    backendUrls.calculataeSafeguardAmounts,
                    {
                        disabilityKey: disabilityKey,
                        beginDate: beginDate.val(),
                        endDate: endDate.val(),
                        bargainingUnit: bargainingUnit.val(),
                        outsideEarnings: outsideEarningsAmount.val(),
                        governmentReortedEarnings: governmentReportedEarningAmount.val(),
                    }
                ).done(function (results) {
                    earningsSafeguardAmount.val(results.earningsSafeguardAmount);
                    retirementAllowanceAmount.val(results.retirementAllowanceAmount);
                    excessEarningsAmount.val(results.excessEarningsAmount);

                }).fail(function () {
                    earningsSafeguardAmount.val(null);
                    retirementAllowanceAmount.val(null);
                    excessEarningsAmount.val(null);

                });
            });
            

            
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);